export default {
  brands: 'eQuoteBrandsData',
  destinations: 'eQuoteDestinationsData',
  labels: 'eQuoteLabelsData',
  ships: 'eQuoteShipsData',
  shipsDestinations: 'eQuoteShipsDestinations'
}
